import moment from 'moment';
import DTO from './DTO';

class MetrologyDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'certificate_number',
        type: String,
        validators: {},
        labelKey: 'metrology.certificate_number',
      },
      {
        name: 'verification_date',
        type: moment,
        validators: {},
        labelKey: 'metrology.date_start',
      },
      {
        name: 'verification_end_date',
        type: moment,
        validators: {},
        labelKey: 'metrology.date_end',
      },
      {
        name: 'certificate_image',
        type: String,
        validators: {},
        labelKey: 'metrology.date_end',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      certificate_number: this.certificate_number,
      date_start: this.date_start,
      date_end: this.date_end,
      certificate_image: this.certificate_image,
    };
  }
}

export default MetrologyDTO;
